import { PlanType } from "@/types/PlanTypes";
import usePlans from "./usePlans";

/**
 * This returns all active plans, including the free plan if there is one!
 */
export default function useActivePlans() {
  const { data: plans, isLoading } = usePlans();
  let activePlans: PlanType[] = [];
  if (plans) {
    activePlans =
      plans.results?.filter((plan) => plan.status === "active") ?? [];
  }
  return { activePlans, isLoading };
}
